import { memo, useState } from 'react'
import { Link } from "react-router-dom"

import NameGraphic from "../images/my_mini_prints_logo_name_only.webp"

const MMPNavbar = memo(function MMPNavbar() {
    const [navOpen, setNavOpen] = useState(false)

    const closeNav = () => setNavOpen(false)

    return <>
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img
                        src={NameGraphic}
                        alt="My Mini Prints company logo"
                        width="140"
                        height="32"
                        loading="eager"
                        decoding="sync"
                        style={{maxWidth: "140px", height: "auto"}}
                    />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setNavOpen(prev => !prev)}
                    aria-controls="navbarSupportedContent"
                    aria-expanded={navOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse${navOpen ? ' show' : ''}`} id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link to="/" className="nav-link active" aria-current="true" onClick={closeNav}>Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="samples" className="nav-link" onClick={closeNav}>Samples</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="prices" className="nav-link" onClick={closeNav}>Prices</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="howtobook" className="nav-link" onClick={closeNav}>How to Book</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="about" className="nav-link" onClick={closeNav}>About</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="blog" className="nav-link" onClick={closeNav}>Blog</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

    </>
})

export default MMPNavbar
